/**
 * The "lifted row" a native drag shows under the pointer (card 1.7, artboard
 * "Drag to move"): the row's glyph and label on a raised, slightly tilted card
 * with a shadow. Built as a detached DOM node because `setDragImage` needs a
 * rendered element; it is parked off-screen and removed right after the
 * browser has taken its snapshot.
 */
import i18n from '../../i18n';

const SVG_NS = 'http://www.w3.org/2000/svg';
const PAGE = ['M6 3h8l5 5v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z', 'M14 3v5h5'];
const FOLDER = ['M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'];

export function makeDragGhost(node) {
  if (typeof document === 'undefined' || !document.body) return null;
  const ghost = document.createElement('div');
  ghost.className = 'doc-tree-drag-ghost';
  ghost.setAttribute('aria-hidden', 'true');
  const icon = document.createElementNS(SVG_NS, 'svg');
  icon.setAttribute('viewBox', '0 0 24 24');
  icon.setAttribute('width', '16');
  icon.setAttribute('height', '16');
  icon.setAttribute('fill', 'none');
  icon.setAttribute('stroke', 'currentColor');
  icon.setAttribute('stroke-width', '1.6');
  icon.setAttribute('stroke-linecap', 'round');
  icon.setAttribute('stroke-linejoin', 'round');
  for (const d of node.type === 'folder' ? FOLDER : PAGE) {
    const path = document.createElementNS(SVG_NS, 'path');
    path.setAttribute('d', d);
    icon.appendChild(path);
  }
  const label = document.createElement('span');
  label.textContent = node.name || i18n.t(node.type === 'folder' ? 'docSidebar.untitledFolder' : 'docSidebar.untitled');
  ghost.append(icon, label);
  document.body.appendChild(ghost);
  setTimeout(() => ghost.remove(), 0);
  return ghost;
}
